<template>
  <div style="max-width:900px; margin: auto;">
 <br />
  
    <h2>Revenue</h2>
   <hr />
   
      <div class="seasoncast-card ">

    <h3>Donation Button <toggle-button v-model="isAccountDonate" :labels="true" :sync="true" v-on:change="updateAccountDonate()"  /></h3><hr />
    <p>By using the donation button, your audience can easily provide support to you or your organization. Donations ranging from $1 to $500 can be made, and the funds are deposited directly into your bank account within a few days. This feature is limited to SeasonCast Premium Broadcasters. A standard 10% + 30 cent processing fee applies. <b v-if="!isAccountDonate">You need to enable the Donation Button by clicking the 'on' button above to start!</b><b v-if="!stripeConnected && isAccountDonate">You will need to 'Create or connect Stripe Account' to setup payment account prior to accepting credit cards!</b></p>
    <div v-if="isAccountDonate">
     <button  v-on:click="sendToStripeSetup"  type="button" v-if="!stripeConnected" class="btn btn-primary">Create or connect Stripe Account</button><a href="https://dashboard.stripe.com/" v-if="stripeConnected" class="btn btn-dark">View Payment Dashboard</a> 
   
    </div>
     </div>
     <br />
    <div class="seasoncast-card ">



    <h3>Virtual SeasonPass Holder <toggle-button v-model="isAccountPaywall" :labels="true" :sync="true" v-on:change="updateAccountPaywall()"  /></h3><hr />
    <p>SeasonPass holders offer a convenient method to generate revenue for your organization through simple credit card payments made by viewers for your content. The income is directly deposited into your bank account within a few days. Enabling this feature restricts access to your channel solely to SeasonPass holders. This feature is limited to SeasonCast Premium Broadcasters. A standard 20% + 30 cent processing fee applies. <b v-if="!isAccountPaywall">You need to enable Virtual SeasonPass Holder by clicking the 'on' button above to start!</b><b v-if="!stripeConnected && isAccountPaywall">You will need to 'Create or connect Stripe Account' to setup payment account prior to accepting credit cards!</b></p>
    <div v-if="isAccountPaywall">
     <button  v-on:click="sendToStripeSetup"  type="button" v-if="!stripeConnected" class="btn btn-primary">Create or connect Stripe Account</button><a href="https://dashboard.stripe.com/" v-if="stripeConnected" class="btn btn-dark">View Payment Dashboard</a> <button type="button" v-on:click="createSeasonPass()" class="btn btn-info">Create SeasonPass for Sale</button> <button type="button" v-on:click="createSeasonPassHolder" class="btn btn-secondary">Create Free SeasonPass Holder</button> 
    <hr />
    
    <p>Your SeasonPass's for Sale: </p>
    <div v-for="seasonPass in currentNewPasses" v-bind:key="seasonPass.name">
      <p>{{seasonPass.name}} - ${{ seasonPass.price / 100}} <button @click="deletePass(seasonPass.id)" class="btn btn-link">[Delete]</button></p>
    </div>
  <p v-if="currentNewPasses.length == 0">no current passes</p>
 
    <br />
    

    <table class="table">
  <thead class="thead-dark">
    <tr>
      <th scope="col">Email</th>
      <th scope="col">Status</th>
      <th scope="col">Expire Date</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="holder in seasonPassHolders" v-bind:key="holder.email" >
      <th scope="row" v-text="holder.email"></th>
      <td >Vaild: {{ holder.isExpired ? "No" : "Yes"}}</td>
      <td v-text="parseTimeStamp(holder.expire)"></td>

    </tr>
  
  </tbody>
</table>
 <p>Contact Customer Support to remove specific SeasonPass Holders prior to expire date.</p>
 </div>
  </div>
  <br />
  </div>
 
</template>
<script>
  import Swal from "sweetalert2"
  import axios from "axios"


  //let API = "http://localhost:8089/"
  let API = "https://app.seasoncast.com/"

export default {
  watch: {
  channel: function () {
     this.getAccount()
    this.isAccountDonate = this.channel.canDonate
    }
},
 props: ['channel'],
    data: function () {
    return {
      stripeConnected: true,
      seasonPassHolders: [],
      currentNewPasses: [],
      isAccountPaywall: false,
      isAccountDonate: false,
   
    }
  },
  methods: {
    deletePass: async function (id){
          let getEventResponse = await axios.post(API+ "v2/broadcaster/payment/seasonPass/delete", {
    ...this.$store.state.broadcasterAuth,
    id: id
  }) 

  let responseData = getEventResponse.data
  console.log(responseData)

  if (responseData.success){
    console.log("vaild")
       Swal.fire({
  icon: 'success',
  title: 'Pass Deleted',
  text: 'SeasonPass is deleted'
})
this.getAccount()
  }else{
 console.log("not vaild")
       Swal.fire({
  icon: 'error',
  title: 'Account Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }
    },
    getAccount: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/broadcaster/payment/information", {
    ...this.$store.state.broadcasterAuth,
  }) 

  let responseData = getEventResponse.data
  console.log(responseData)

  if (responseData.success){
    console.log("vaild")
    this.stripeConnected = responseData.stripeConnected
    this.seasonPassHolders = responseData.seasonPassHolders
    this.currentNewPasses = responseData.currentNewPasses
    this.isAccountPaywall = responseData.isAccountPaywall
  }else{
 console.log("not vaild")
       Swal.fire({
  icon: 'error',
  title: 'Account Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }

    },
    createSeasonPassHolder: async function () {



    const { value: email } = await Swal.fire({
  title: 'Viewer email address',
  input: 'email',
  inputPlaceholder: 'Enter a email address to give a SeasonPass'
})


if (email) {
  let options = {}
  for (let index = 0; index < this.currentNewPasses.length; index++) {
    const element = this.currentNewPasses[index];
    options[element.time] = element.name
    
  }
   const { value: time } = await Swal.fire({
  title: 'Select SeasonPass Pass Type',
  input: 'select',
  inputOptions: options,
  inputPlaceholder: 'Select a Pass',
  showCancelButton: true
})

if (time) {
this.requestSeasonPassHolder(email,time)
}
}

    },
       requestSeasonPassHolder: async function (email, time) {
        let getEventResponse = await axios.post(API+ "v2/broadcaster/payment/seasonPass/customer/create", {
    ...this.$store.state.broadcasterAuth,
    viewer_email: email,
    time: parseInt(time)
  }) 

  let responseData = getEventResponse.data
  console.log(responseData)

  if (responseData.success){
    console.log("vaild")
    this.getAccount()
  }else{
 console.log("not vaild")
       Swal.fire({
  icon: 'error',
  title: 'Account Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }
       },

    parseTimeStamp(ts){
      return new Date(ts*1000).toLocaleDateString()
    },
    sendToStripeSetup: async function () {
      location.href = "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_CvLXQFMvSumAGkn7sLXEje5T9gP13AMa&scope=read_write&stripe_user[email]="+this.channel.email
    },
    createSeasonPass: async function () {
      if (!this.stripeConnected){
           Swal.fire({
  icon: 'error',
  title: 'No Payment Account',
  text: 'You need to connect a stripe account to accept payment.',
  footer: 'Stripe is how we payout to our broadcasters.'
})
return
      }

      var input = {
    
      1: '1 Day',
      3: '3 Days',
      5: '5 Days',
      7: '7 Days',
      14: '2 Weeks',
      31: '1 Month',
      92: '3 Months',
      180: '6 Months',
      365: '12 Months',
    
  }
const { value: time } = await Swal.fire({
  title: 'Select duration of new SeasonPass',
  input: 'select',
  inputOptions: input,
  inputPlaceholder: 'Select a duration',
  showCancelButton: true,
 
  
})

if (!time) {
 return
}

let secounds = 86400 * time

const { value: name } = await Swal.fire({
  title: 'Enter the name of the new SeasonPass',
  input: 'text',
  inputValue: "SeasonPass - "+input[time],
  showCancelButton: true,
})

if (!name) {
  return
}

const { value: price } = await Swal.fire({
  title: 'Enter the price of the new SeasonPass. ($3 min.)',
  input: 'text',
  inputValue: 35.99,
  showCancelButton: true,
})

if (!price) {
  return
}
let priceInt = parseInt(price*100)

if (priceInt < 300){
  return
}
    let getEventResponse = await axios.post(API+ "v2/broadcaster/payment/seasonPass/create", {
    ...this.$store.state.broadcasterAuth,
    name: name,
    time: parseInt(secounds),
    price: priceInt
  }) 

  let responseData = getEventResponse.data
  console.log(responseData)

  if (responseData.success){
    console.log("vaild")
    this.getAccount()
  }else{
 console.log("not vaild")
       Swal.fire({
  icon: 'error',
  title: 'Account Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }
    },
      updateAccountPaywall: async function () {
     
     let response =  await axios.post(API+ "v2/broadcaster/payment/seasonPass/status", {
    ...this.$store.state.broadcasterAuth,
    status: this.isAccountPaywall,
    
  })
  console.log(response) 
  },
    updateAccountDonate: async function () {
     
     let response =  await axios.post(API+ "v2/broadcaster/payment/donate/status", {
    ...this.$store.state.broadcasterAuth,
    status: this.isAccountDonate,
    
  })
  console.log(response) 
  }
  },
  
   created: async function () {
    console.log("create call")


      if (!this.$store.state.broadcasterAuth){ location.href="https://dashboard.seasoncast.com"}

  this.getAccount()
 this.isAccountDonate = this.channel.canDonate
   }
}
</script>

